import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import cx from "clsx";
import { useFormContext } from "react-hook-form";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getUserPaymentSystem } from "../../utilities/localStorage";
import { USER_PAYMENT_SYSTEMS } from "../../consts/api";
import { getCurrencySymbol, initializeClearentSdk } from "../../Utils";
import classes from "./sass/membership.module.scss";
import { uiNotification } from "../../services/UINotificationService";
import StripePaymentForm from "../Sales/FrontdeskCheckout/StripePaymentForm";
import { getSetupIntent } from "../../Actions/Stripe/StripeActions";
import { Select } from "../../shared/Select/Select";
import { Tabs } from "../../shared/Tabs/Tabs";
import { InputLabel } from "../../shared/InputLabel/InputLabel";
import { InputCurrency } from "../../shared/InputCurrency/InputCurrency";
import { Skeleton } from "../../shared/Skeleton/Skeleton";
import { AlertBox } from "../../shared/AlertBox/AlertBox";
import { InfoIcon } from "../../assets/Icons/InfoIcon";

const MembershipPayment = ({
  notDisplayTitle,
  clearentClinic,
  clientId,
  cardList,
  getSetupIntent,
  updateProceedState,
  updateCardSelected,
  validation,
  onSubmit,
  onCancel,
  isAddMembership,
  selectedClinicId,
  clearentCardsList,
  changeClearentCard,
  selectedClearentCard,
  cardOnFile,
  setCardOnFile,
  totalAmount,
  paymentType,
  setPaymentType,
  membershipPaymentFrequency,
  isMembershipDetailsLoading,
  isKlarnaEnabled,
  klarnaPhone,
  onKlarnaPhoneChange,
}) => {
  const [cardType, setCardType] = useState("saved");
  const [cardSelected, setCardSelected] = useState("");

  const userPaymentSystem = getUserPaymentSystem();
  const isStripe = userPaymentSystem === USER_PAYMENT_SYSTEMS.stripe;

  const { register } = useFormContext();

  useEffect(() => {
    if (
      !isEmpty(clearentClinic) &&
      userPaymentSystem === USER_PAYMENT_SYSTEMS.clearent
    ) {
      if (clearentClinic.publickey === null) {
        uiNotification.error("POS is not setup for this clinic.");
      } else if (clearentClinic.publickey) {
        initializeClearentSdk(clearentClinic.publickey, "payment-form");
      }
    }
  }, [clearentClinic, userPaymentSystem, cardOnFile]);

  useEffect(() => {
    if (isStripe && selectedClinicId) {
      getSetupIntent({ patient_id: clientId, clinic_id: selectedClinicId });
    }

    if (cardList?.length) {
      setCardType("saved");
      updateProceedState(true);
    } else {
      setCardType("new");
      updateProceedState(false);
    }
  }, [selectedClinicId]);

  const handleInputChange = () => {
    if (cardType === "saved") {
      setCardType("new");
      updateProceedState(false);
    } else if (cardType === "new" && cardList?.length) {
      setCardType("saved");
      updateProceedState(true);
    }
  };

  const changeCardSelected = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setCardSelected(value);
    updateCardSelected(value);
  };

  const handlePaymentTypeChange = (e) => {
    const value = e.target.value;
    setPaymentType(value);
    if (value === "cash" || value === "klarna") {
      updateProceedState(true);
    }
    if (value === "cc") {
      updateProceedState(cardList?.length > 0);
    }
  };

  useEffect(() => {
    const primary = cardList?.find((card) => card.is_primary);
    if (cardList?.length === 1) {
      setCardSelected(cardList[0].id);
    } else if (primary) {
      setCardSelected(primary.id);
    }
  }, [cardList]);

  const showCashPaymentOption =
    totalAmount > 0 && membershipPaymentFrequency?.toLowerCase() === "yearly";

  return (
    <div className={classes.payment}>
      <div className="row m-b-15">
        {userPaymentSystem === USER_PAYMENT_SYSTEMS.stripe && (
          <>
            {!notDisplayTitle && (
              <div className="col-xs-12">
                <div className={classes.fieldTitle}>PAYMENT DETAILS</div>
              </div>
            )}
            <div className="row col-sm-12">
              <div className="col-xs-12">
                <div className={cx(classes.paymentTypeOptionsContainer)}>
                  {isAddMembership &&
                    (membershipPaymentFrequency?.toLowerCase() === "yearly" ||
                      isKlarnaEnabled) && (
                      <>
                        <div className={cx(classes.radioOptionsRow)}>
                          <input
                            type="radio"
                            name="paymentType"
                            id="cc"
                            value="cc"
                            checked={paymentType === "cc"}
                            onChange={(e) => handlePaymentTypeChange(e)}
                          />
                          <label htmlFor="cc">Credit Card</label>
                        </div>
                        {showCashPaymentOption && (
                          <div className={cx(classes.radioOptionsRow)}>
                            <input
                              type="radio"
                              name="paymentType"
                              id="cash"
                              value="cash"
                              checked={paymentType === "cash"}
                              onChange={(e) => handlePaymentTypeChange(e)}
                            />
                            <label htmlFor="cash">Cash</label>
                          </div>
                        )}
                        {isKlarnaEnabled && (
                          <div className={cx(classes.radioOptionsRow)}>
                            <input
                              type="radio"
                              name="paymentType"
                              id="klarna"
                              value="klarna"
                              checked={paymentType === "klarna"}
                              onChange={(e) => handlePaymentTypeChange(e)}
                            />
                            <label htmlFor="klarna">
                              <img
                                src="/images/klarna.png"
                                alt="Klarna"
                                style={{
                                  height: 20,
                                  verticalAlign: "middle",
                                  marginRight: 4,
                                }}
                              />
                              Klarna
                            </label>
                          </div>
                        )}
                      </>
                    )}
                </div>
              </div>
            </div>
            {paymentType === "cc" && (
              <div className="row col-sm-12">
                <div className="col-xs-12 p-l-40">
                  <div className={cx(classes.cardOptionsContainer)}>
                    {cardList?.length ? (
                      <div className={cx(classes.radioOptionsRow)}>
                        <input
                          type="radio"
                          name="cardType"
                          id="saved"
                          value="saved"
                          checked={cardType === "saved"}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="saved">Saved Cards</label>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className={cx(classes.radioOptionsRow)}>
                      <input
                        type="radio"
                        name="cardType"
                        id="new"
                        value="new"
                        checked={cardType === "new"}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="new">New Card</label>
                    </div>
                  </div>
                  {cardType === "saved" ? (
                    <div className="col-xs-12">
                      <div className="new-field-label">Credit Card(s)</div>

                      <select
                        className="setting-select-box"
                        value={cardSelected}
                        onChange={changeCardSelected}
                      >
                        {!cardSelected && <option value="">Select card</option>}
                        {cardList?.length &&
                          cardList.map((obj) => {
                            const last4 = obj.card.last4
                              ? ` ending with ${obj.card.last4}`
                              : "";
                            return (
                              <option key={obj.id} value={obj.id}>
                                {obj.card.brand}
                                {last4}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  ) : (
                    <StripePaymentForm
                      type="setupIntent"
                      onSubmit={onSubmit}
                      onCancel={onCancel}
                      validation={validation}
                      onSubmitText={isAddMembership ? "Proceed" : "Save"}
                    />
                  )}
                </div>
              </div>
            )}
            {paymentType === "klarna" && (
              <div className="row col-sm-12">
                <div className="col-xs-6 p-l-40">
                  <InputLabel>Patient Phone Number</InputLabel>
                  <input
                    className="simpleInput"
                    type="tel"
                    placeholder="e.g. +1 212 555 0123"
                    value={klarnaPhone || ""}
                    onChange={(e) =>
                      onKlarnaPhoneChange && onKlarnaPhoneChange(e.target.value)
                    }
                  />
                </div>
                <div className="col-xs-12 m-t-20">
                  <AlertBox className="flex gap-8">
                    <InfoIcon width="17px" />
                    <span className="m-t-3">
                      The patient will receive an SMS with a Klarna checkout
                      link. After they complete payment, their membership will
                      be activated automatically.
                    </span>
                  </AlertBox>
                </div>
              </div>
            )}
            {paymentType === "cash" && (
              <div className="row col-sm-12">
                <div className="col-xs-6 p-l-40">
                  <InputLabel>Payment Amount</InputLabel>
                  {isMembershipDetailsLoading ? (
                    <Skeleton width="270px" height="36px" />
                  ) : (
                    <InputCurrency
                      size="small"
                      name="paymentAmount"
                      prefix={getCurrencySymbol()}
                      defaultValue={parseFloat(totalAmount).toFixed(2)}
                      value={parseFloat(totalAmount).toFixed(2)}
                      isDisabled
                    />
                  )}
                </div>
                <div className="col-xs-12 m-t-20">
                  <AlertBox className="flex gap-8">
                    <InfoIcon width="17px" />
                    <span className="m-t-3">
                      This membership will not auto-renew because no credit card
                      is on file for automated charges.
                    </span>
                  </AlertBox>
                </div>
              </div>
            )}
          </>
        )}

        {userPaymentSystem === USER_PAYMENT_SYSTEMS.clearent &&
          clearentClinic.publickey && (
            <>
              {!notDisplayTitle && (
                <div className="col-xs-12">
                  <div className={classes.fieldTitle}>PAYMENT DETAILS</div>
                </div>
              )}
              {isAddMembership &&
                membershipPaymentFrequency?.toLowerCase() === "yearly" && (
                  <div className="row col-sm-12">
                    <div className="col-xs-12">
                      <div className={cx(classes.paymentTypeOptionsContainer)}>
                        <div className={cx(classes.radioOptionsRow)}>
                          <input
                            type="radio"
                            name="paymentType"
                            id="cc"
                            value="cc"
                            checked={paymentType === "cc"}
                            onChange={(e) => handlePaymentTypeChange(e)}
                          />
                          <label htmlFor="cc">Credit Card</label>
                        </div>
                        {showCashPaymentOption && (
                          <div className={cx(classes.radioOptionsRow)}>
                            <input
                              type="radio"
                              name="paymentType"
                              id="cash"
                              value="cash"
                              checked={paymentType === "cash"}
                              onChange={(e) => handlePaymentTypeChange(e)}
                            />
                            <label htmlFor="cash">Cash</label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              {paymentType === "cc" && (
                <>
                  <div className="col-xs-12 flex justify-center m-b-20">
                    <Tabs
                      variant="tiled"
                      active={cardOnFile ? "cardOnFile" : "newCard"}
                      options={[
                        {
                          label: "New Card",
                          value: "newCard",
                          onClick: () => setCardOnFile(false),
                        },
                        {
                          label: "Card On File",
                          value: "cardOnFile",
                          onClick: () => setCardOnFile(true),
                        },
                      ]}
                    />
                  </div>
                  {cardOnFile ? (
                    <div className="col-xs-12">
                      <div className="col-xs-12 p-l-0">
                        <div className={classes.fieldTitle}>Select Card</div>
                        <div className={cx(classes.formField, "p-0")}>
                          <Select
                            value={selectedClearentCard}
                            onChange={(value) => changeClearentCard(value)}
                            options={clearentCardsList}
                            placeholder="Select"
                            name="select-card"
                            size="small"
                            className="p-t-0"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div id="payment-form" className={classes.clearentForm} />
                  )}

                  <div className="col-sm-6 col-xs-12 payment-field">
                    <div className=" clear-relative">
                      <div className={cx("simpleField", classes.formField)}>
                        <input
                          className="simpleInput"
                          name="clearentZip"
                          type="text"
                          autoComplete="off"
                          placeholder={"Zip"}
                          {...register("clearentZip")}
                        />
                      </div>

                      <div className={cx("simpleLabel", classes.paymentTitle)}>
                        Zip
                        <span className="required m-l-5">*</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-xs-12 payment-field">
                    <div className=" clear-relative">
                      <div className={cx("simpleField", classes.formField)}>
                        <input
                          className="simpleInput"
                          name="clearentEmail"
                          type="text"
                          autoComplete="off"
                          placeholder={"Email"}
                          {...register("clearentEmail")}
                        />
                      </div>

                      <div className={cx("simpleLabel", classes.paymentTitle)}>
                        Email
                        <span className="required m-l-5">*</span>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {paymentType === "cash" && (
                <div className="row col-sm-12">
                  <div className="col-xs-6 p-l-40">
                    <InputLabel>Payment Amount</InputLabel>
                    {isMembershipDetailsLoading ? (
                      <Skeleton width="270px" height="36px" />
                    ) : (
                      <InputCurrency
                        size="small"
                        name="paymentAmount"
                        prefix={getCurrencySymbol()}
                        defaultValue={parseFloat(totalAmount).toFixed(2)}
                        isDisabled
                      />
                    )}
                  </div>
                  <div className="col-xs-12 m-t-20">
                    <AlertBox className="flex gap-8">
                      <InfoIcon width="17px" />
                      <span className="m-t-3">
                        This membership will not auto-renew because no credit
                        card is on file for automated charges.
                      </span>
                    </AlertBox>
                  </div>
                </div>
              )}
            </>
          )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cardList: state.StripeReducer.cardList?.filter((c) => c.card.last4),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getSetupIntent }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MembershipPayment);
